/**
 * MotionIcon — A square and the trail it leaves: something that moves. Hugeicons motion-02 (MIT).
 */

import svg from './svg/motion.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const MotionIcon = makeSvgIcon('motion', svg);
